import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LowPriority from '@material-ui/icons/LowPriority';
import ChangeShashokuOptionDialog from '../molecules/ChangeShashokuOptionDialog';

const styles = {
  fixedWidthButton: {
    width: 220,
    whiteSpace: 'normal',
    textAlign: 'left',
    justifyContent: 'flex-start'
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('gochimeshiFlag', 'setGochimeshiFlag', 0),
  withState('shashokuFlag', 'setShashokuFlag', 0),
  withState('gochiKidFlag', 'setGochiKidFlag', 0),
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false)
);

const button = enhance(
  ({
    classes,
    openChange,
    disabled,
    updateOpenChange,
    params,
    onClickAction,
    gochimeshiFlag,
    setGochimeshiFlag,
    shashokuFlag,
    setShashokuFlag,
    gochiKidFlag,
    setGochiKidFlag,
    openChangeConfirm,
    updateOpenChangeConfirm,
    titleStatus
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      const param = {
        menuId: paramChange.id,
        gochimeshiFlag,
        shashokuFlag
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onClickAction(param);
    };
    const updateChange = () => {
      updateOpenChange(true);
      setGochimeshiFlag(params.gochimeshiFlag);
      setShashokuFlag(params.shashokuFlag);
      setGochiKidFlag(params.gochiKidFlag);
    };
    let disableStatus = false;
    if (params.disabled) {
      disableStatus = true;
    }
    return (
      <div>
        <Button
          className={classes.fixedWidthButton}
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          <LowPriority className={classes.leftIcon} />
          {titleStatus}
        </Button>
        <ChangeShashokuOptionDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={() => changeAction(params)}
          target="Change"
          gochimeshiFlag={gochimeshiFlag}
          setGochimeshiFlag={setGochimeshiFlag}
          shashokuFlag={shashokuFlag}
          setShashokuFlag={setShashokuFlag}
          gochiKidFlag={gochiKidFlag}
          setGochiKidFlag={setGochiKidFlag}
          disableStatus={disableStatus}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
